import { HttpClient } from '@/shared/lib/http-client';

export const loginUser = async({ email, password }) => {
  const response = await HttpClient.post('/auth/login', {
    email,
    password,
    is_web: true
  });

  return response.data?.data;
};
